<template>
    <PageWapper>
        <BannerSDK />
        <Info />
        <Download />
    </PageWapper>
</template>

<script>
import PageWapper from "@/components/PageWapper.vue";
import BannerSDK from "./components/BannerSDK.vue";
import Download from "./components/Download.vue";
import Info from "./components/Info.vue";

export default {
    components: { PageWapper, BannerSDK, Info, Download }
};
</script>
